document.addEventListener('DOMContentLoaded', () => {

	const accordionFunc = () => {
		const medicalAccordion = document.querySelector('.js-accordion');

		// コンテンツ内スライドトグル
		if(medicalAccordion !== null){
			// アコーディオンボタン
			const slideToggleBtn = document.querySelectorAll('.js-accordion__trigger');

			// アコーディオンイベント
			slideToggleBtn.forEach((target, index) => {
				target.addEventListener('click', (e) => {
					e.preventDefault();

					// 開閉
					const el = document.querySelectorAll('.js-accordion__container')[index];
					slideToggle(el, 300);

					// toggleClass
					const targetParent = target.parentNode;
					targetParent.classList.toggle('is__open');
				});
			})
		}
  }

	const searchWord = function(e){
		e.preventDefault();

		var searchText = $('.o-search__text').val(), // 検索ボックスに入力された値
				targetText;

		// 検索ボックスに値が入ってる場合
		if (searchText != '') {
			$('#js-container .target-area').css('display', 'block')
			$('.target-area').each(function(index) {
				targetText = $(this).text();

				// 検索対象となるリストに入力された文字列が存在するかどうかを判断
				console.log(searchText);
				if (targetText.indexOf(searchText) === -1) {
					// 存在する場合はそのリストのテキストを用意した配列に格納
					let targetObj = $('#js-container .target-area').eq(index).css('display', 'none');
				}
			});
		}
	};

	// searchWordの実行
	$('#js-searchButton').on('click', searchWord);

	// json検索
	const templateHTML = $('#template').text();
	const $container = $('#js-container');
	let rendered = '';
	let bindData = {};

	$.ajax({
		url: '/assets/js/jsonData/medicalFacilities.json',
		get: 'get',
		dataType: 'json',
	}).done((response) => {
		var main_category_title = response.main_category_title;
		var main_category_length = response.contents.length;
		$('#js-listTitle').text(main_category_title + '一覧' + '(' + main_category_length + ')');

		bindData['article'] = response.contents.map((data) => {
			bindData['product'] = response.contents.map((data) => {
				return data;
			});
			data.contents_length = data.product.length;
			return data;
		});

		if(templateHTML){
			rendered = Mustache.render(templateHTML, bindData);
			$container.append(rendered);
		}

		accordionFunc();

	}).fail((error) => {
		console.log(error);
	});

});
